import { Box } from '@chakra-ui/react';

import { useModules } from '@izimi/modules';

import { FeatherIcon } from '../icon';

export const NavigationNotificationsIcon = () => {
  const {
    notifications: { useLastNotifications },
  } = useModules();
  const { hasUnreadNotifications } = useLastNotifications();

  return (
    <Box pos='relative'>
      <Box
        w={3}
        h={3}
        pos='absolute'
        rounded='lg'
        top='1px'
        right={0}
        display='flex'
        alignItems='center'
        justifyContent='center'>
        {hasUnreadNotifications ? <Box w={2} h={2} bg='secondary400' rounded='lg' /> : null}
      </Box>
      <FeatherIcon name='bell' stroke='current' />
    </Box>
  );
};
